import { useContext, useEffect, useState } from "react";
import {useHistory} from 'react-router-dom';
import { setShop } from "../authContext/AuthActions";
import { AuthContext } from "../authContext/AuthContext";
import { Card, CardContent, Typography, CircularProgress, Box } from '@mui/material'
import React from 'react'
import StoreIcon from '@mui/icons-material/Store';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import LoaderDialog from './LoaderDialog';

export default function LoginShop({ allowedShops = [] }) {
  const { dispatch, user } = useContext(AuthContext);
  const history = useHistory();
  const [shopsList, setShopsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [enteringShop, setEnteringShop] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const loadShops = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/shops/userShops", {headers: {token:"Bearer " + user.token}});
        if (isMounted) setShopsList(res.data && res.data.length > 0 ? res.data : allowedShops);
      } catch (err) {
        console.log("Error fetching user shops:", err);
        if (isMounted) setShopsList(allowedShops);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    if (user) loadShops();
    return () => {
      isMounted = false;
    };
  }, [user, allowedShops]);

  const handleLoginShop = async (e, shopkey) => {
    e.preventDefault();
    if (enteringShop) return;
    setEnteringShop(true);
    
    const shop = shopsList.find((s) => s.shopkey === shopkey) || allowedShops.find((s) => s.shopkey === shopkey);
    const selectedShop = { ...shop };

    try {
      const settingsRes = await axios.get("/settings", {headers: {token:"Bearer " + user.token, shopkey: selectedShop.shopkey}});
      selectedShop.settings = Array.isArray(settingsRes.data) ? settingsRes.data : [];
      if (selectedShop.settings.length === 0) throw new Error("Fallback to find");
    } catch (err) {
      try {
        const fallbackRes = await axios.get(`/settings/find?shopKey=${selectedShop.shopkey}`, {headers: {token:"Bearer " + user.token}});
        if (fallbackRes.data && fallbackRes.data.settings) {
          selectedShop.settings = [fallbackRes.data];
        } else {
          selectedShop.settings = [];
        }
      } catch (e) {
        console.log("Error fetching settings:", e);
        selectedShop.settings = [];
      }
    }
    dispatch(setShop(selectedShop, user));
    setEnteringShop(false);
    history.push('/home');
  };
  
  return (
    <Container maxWidth={false} disableGutters sx={{ height: "92vh", width: "100vw", p: 2 }}>
      <LoaderDialog open={enteringShop} title="Entering Shop..." />
      <h1 align="center">Select Your Login Shop</h1>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : (
        shopsList.length > 0 ? (
          <Grid container spacing={2} alignItems="stretch">
            {shopsList.map((shop) => (
              <Grid key={shop.shopkey} item xs={4}>
                <Card 
                  sx={{ 
                      height: '100%', 
                      minHeight: 350, 
                      display: 'flex', 
                      flexDirection: 'column', 
                      justifyContent: 'center', 
                      cursor: "pointer",
                      transition: '0.3s', 
                      '&:hover': { transform: 'translateY(-5px)', boxShadow: 6 } 
                  }} 
                  onClick={e => handleLoginShop(e, shop.shopkey)} 
                >
                  <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <StoreIcon style={{ color: "#1776d1", fontSize: 240 }} />
                    <Typography gutterBottom variant="h5" component="div" align="center" noWrap sx={{ color: "#1776d1", fontSize: 32, textDecoration: 'none', width: '100%', mt: 2 }}>
                      {shop.shopname} - {shop.shopkey}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="h6" align="center" sx={{ mt: 4, color: 'text.secondary' }}>
            No shops available for your account. Please contact an administrator.
          </Typography>
        )
      )}
    </Container>
  );
}